import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseQueryWithAuth = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_BASE_URL,
  prepareHeaders: (headers, { getState }) => {
    const token = localStorage.getItem("token");

    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }

    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQueryWithAuth(args, api, extraOptions);

  // Handle 401 Unauthorized - session expired or invalid token
  if (result?.error?.status === 401) {
    // Clear all authentication data
    localStorage.clear();

    // Redirect to login page
    window.location.href = "/login";

    // Return error with custom message
    return {
      error: {
        status: 401,
        data: { message: "Your session has expired. Please log in again." },
      },
    };
  }

  return result;
};

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReauth,
  refetchOnFocus: false,
  refetchOnReconnect: true,
  tagTypes: [
    "Login",
    "PermissionRoles",
    "Students",
    "Student",
    "Dashboard",
    "Courses",
    "Course",
    "Employees",
    "Employee",
    "Packages",
    "Package",
    "Countries",
    "Timezones",
    "LiveClass",
    "CourseStaff",
    "MockTests",
    "TeacherAvailability",
  ],
  endpoints: (builder) => ({
    // your endpoints here
  }),
});
